'use client';

import { z } from 'zod';

import { QuizPlanOrderResponsePlanType } from '@/api/gen/_model/quizPlanOrderResponsePlanType';

// API 타입을 기반으로 한 스키마 정의
export const getPlanSchema = () =>
  z
    .nativeEnum(QuizPlanOrderResponsePlanType)
    .default(QuizPlanOrderResponsePlanType.PRO);

// API 타입 재사용
export type PlanType = QuizPlanOrderResponsePlanType;
